import classNames from 'classnames'
import React from 'react'
import './PageHeader.css'

export const HeaderButton = ({
                                 component,
                                 className,
                                 round = 'full',
                                 innerClass,
                                 style = {},
                                 width = 50,
                                 height = 50,
                                 iconStyle = {},
                                 icon,
                                 onClick,
                                 children,
                                 ...props
                             }) => {
    return React.createElement(component ? component : 'div', {
        onClick,
        className: classNames(
            'flex justify-center items-center flex-shrink-0',
            className
        ),
        style: {
            width,
            height: height,
            ...style,
        },
        children: (
            <div
                className={classNames(
                    'flex flex-center bg-indigo-100 hover:bg-indigo-200 text-secondary hover:text-indigo-700 cursor-pointer',
                    `rounded-${round}`,
                    innerClass
                )}
                style={{
                    width: width,
                    height: height,
                }}>
                {icon && icon}
                {children}
            </div>
        ),
        ...props,
    })
}
